import { TranslationResponseData } from '@/shared/types';

const prepareTranslations = (
  translations: TranslationResponseData[],
): Record<string, string> =>
  translations.reduce((acc, { name, text }) => ({ ...acc, [name]: text }), {});

export default prepareTranslations;
